import React from "react";
import "./style.scss";
import PageContainer from "../PageContainer";

const ComingSoon: React.FC = () => {
  return (
    <>
      <PageContainer>
        <div className="coming-soon-container">
          <div className="coming-soon-content">
            <h1 className="coming-soon-title">Coming Soon</h1>
            <p className="coming-soon-subtitle">
              This feature is under development and will be available soon.
            </p>
            <div className="coming-soon-animation">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default ComingSoon;
